// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__37QgT","expandIconWrapper":"CustomNode_expandIconWrapper__PxPmZ","isOpen":"CustomNode_isOpen__28ZQk","labelGridItem":"CustomNode_labelGridItem__1sdAt"};